import { render, staticRenderFns } from "./InstagramAccountsTable.vue?vue&type=template&id=70cb79b6&"
import script from "./InstagramAccountsTable.vue?vue&type=script&lang=js&"
export * from "./InstagramAccountsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports